export default __webpack_public_path__ + "static/media/wayfarer.206980f6.png";